<script>
    import { onMount, onDestroy, tick } from "svelte";
    import { writable, get } from 'svelte/store';


    import {
        db,
        activeConversation,
        userID,
        clientUserID,
        splashScreenArtUrl,
        assistantIconUrl,
        textCopy,
        emailHash,
        socketStore,
        isStreaming,
        footerLinkData,
        isStatelessUserFlag,
        statelessMessages,
        daMessageId,
        addStatelessMessage,
        isCollapsed,
    } from "../stores.js";
    import AiAgentToggle from "./AiAgentToggle.svelte";
    import Message from "./MessageArea.svelte";
    import TextInputArea from "./TextInputArea.svelte";
    import { getTextStreamStore, clearTextStreamStore } from "../websocketService.js";

    let messages = [];
    let displayedMessages = [];
    $: displayedMessages = $isStatelessUserFlag ? $statelessMessages : messages;

    let showSplashScreen = false; // Flag for showing splash screen
    let firestoreContentLoaded = false; // Tracks if Firestore content is loaded and relevant
    let storeContentLoaded = false; // Tracks if the store has relevant content

    let messagesStyle = ""; // Variable for dynamic messages style
    let messageStatusListeners = {};
    let conversationStatus = '';
    let statusClass = '';
    let isLoading = false; // State to manage loading
    let textStreamStore;
    let shouldDisplayTexStreamMessage = false;
    let previousActiveConversationForDisplay = null;
    let previousActiveConversationForStream = null;
    
    let currentTextStreamConvoId = null;
    let messagesListenerUnsubscribe = null; // Store the unsubscribe function for the Firestore listener

    let statelessUserInit = false;



    // Function to check if the device is in portrait mode and log the state
    const isPortrait = () => {
        const portrait = window.matchMedia("(orientation: portrait)").matches;
        console.log(`Checking orientation: ${portrait ? 'Portrait' : 'Landscape'}`);
        return portrait;
    };

    // Initial check and log
    let portraitMode = isPortrait();

    // Reactive statements to apply classes based on isCollapsed and orientation
//    $: splashScreenClass = !$isCollapsed && portraitMode ? 'hidden' : '';
//    $: textAreaClass = $isCollapsed || !portraitMode ? 'no-interaction' : '';
    $: unifiedClassName = !$isCollapsed && portraitMode ? 'hidden no-interaction' : '';

    $: {
        portraitMode = isPortrait(); // Re-check whenever dependencies change
        console.log(`isCollapsed: ${$isCollapsed}, portraitMode: ${portraitMode}`);
    }

    // Ensure updates on orientation change or window resize
    window.addEventListener('resize', () => {
        portraitMode = isPortrait(); // Update the state and log
    });

    let styleOverrides = ''; // Initially define the variable outside the reactive block
    $: {
        const fadeOutDuration = '0s'; // Longer fade out
        const fadeInDuration = '0.9s'; // Quicker fade in
        styleOverrides = !$isCollapsed && portraitMode 
                         ? `opacity: 0; visibility: hidden; --fade-duration: ${fadeOutDuration};`
                         : `opacity: 1; visibility: visible; --fade-duration: ${fadeInDuration};`;
        console.log(`Style applied: ${styleOverrides}`);
    }






$: if (messages) {
    console.log('Messages array changed:', messages);
}

$: if (shouldDisplayTexStreamMessage) {
    console.log('shouldDisplayTexStreamMessage changed:', shouldDisplayTexStreamMessage);
}


    $: {
        if (conversationStatus === 'received...') {
            statusClass = 'status-color-x';
        } else if (conversationStatus === 'finding the answer...') {
            statusClass = 'status-color-blahblah';
        } else if (conversationStatus === 'replying...') {
            statusClass = 'status-color-yoyo';
        } else {
            statusClass = ''; // Default class or leave empty
        }
    }
$: if (showSplashScreen){
    console.log("SplashScreen Flipped:", showSplashScreen);
}


    // Di reactive statement fi listen fi changes to activeConversation
$: if ($activeConversation) {
    if ($activeConversation !== previousActiveConversationForDisplay) {
        conversationStatus = '';
        displayActiveConversation($activeConversation);
        console.log("These are sss fcl and scl:", showSplashScreen, firestoreContentLoaded, storeContentLoaded);
        previousActiveConversationForDisplay = $activeConversation;
    }
}

    $: if ($activeConversation && $socketStore) {
        if ($activeConversation !== previousActiveConversationForStream) {
            setupTextStreamListener($activeConversation);
            previousActiveConversationForStream = $activeConversation;
        }
    }


    $: if ($isStatelessUserFlag && $daMessageId) {
        displayActiveConversation2($daMessageId);
        //setupStatusListener2($daMessageId);
    }


    $: if ($isStatelessUserFlag && $socketStore) {
        setupTextStreamListener2();   
    }


    $: if ($isStatelessUserFlag && !statelessUserInit) {
        showSplashScreen = true;
        statelessUserInit = true;
    }

/*
    $: if ($textStreamStore) {
        if (shouldDisplayTexStreamMessage){
        console.log("we sDTSM true")
        storeContentLoaded = true;
        updateSplashScreenVisibility();
    } else {
        console.log("we sDTSM false")
        storeContentLoaded = false;
        updateSplashScreenVisibility();
    }
    }
*/

    function updateSplashScreenVisibility() {
        showSplashScreen = !firestoreContentLoaded && !storeContentLoaded;
    }

    function scrollToBottom() {
        // Select the container using vanilla JavaScript
        const messagesContainer = document.querySelector(".messages");
        if (messagesContainer) {
            messagesContainer.scrollTop = messagesContainer.scrollHeight;
        }
    }

    // Use onMount to ensure we're in the browser
    onMount(() => {
        scrollToBottom(); // Call this when the component first mounts
    });


    function displayActiveConversation(convoId) {
        try {
        // Reset the flag for Firestore content each time a new conversation is displayed
        firestoreContentLoaded = false;

        // Cleanup previous status listeners if any
        Object.values(messageStatusListeners).forEach(unsubscribe => unsubscribe());
        messageStatusListeners = {};

        // Detach the previous Firestore messages listener if it exists
        if (messagesListenerUnsubscribe) {
            messagesListenerUnsubscribe();
            messagesListenerUnsubscribe = null;
        }

        // Set up real-time listener for changes in Firestore
        const messagesRef = $db
            .collection("users")
            .doc($userID)
            .collection("deploymentUserData")
            .doc($clientUserID)
            .collection("clientSubUsers")
            .doc($emailHash) // Insert the user's email hash into the path
            .collection("conversations")
            .doc(convoId)
            .collection("messages");

        console.log(`Setting up listener for conversation ${convoId}`);
        messagesListenerUnsubscribe = messagesRef.orderBy("timestamp", "asc").onSnapshot((snapshot) => {
            try {
                let newFirestoreMessages = snapshot.docs.map((doc) => {
                    let messageData = doc.data();
                    return {
                        type: messageData.message.role,
                        text: messageData.message.content,
                        modeId: messageData.modeId || null,
                        messageId: doc.id, // Store the messageId
                    };
                });

                // Check if the textStreamStore is defined
                if (textStreamStore && convoId === currentTextStreamConvoId) {
                    // Update the textStreamStore with the new Firestore messages
                    textStreamStore.update(store => {
                        let updatedStore = store.filter(m => !newFirestoreMessages.find(fm => fm.messageId === m.messageId));
                        return updatedStore;
                    });
                    if (get(textStreamStore).find(m => m.finishedStreaming)) {
                        console.log("WE DELETING TEXTSTREAM STORE @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");
                        textStreamStore.set([]);
                    }
                }
                

                // Set the messages array with the new Firestore messages
                messages = newFirestoreMessages;
                console.log("We running the dAC message array set block, this is messages.length:", messages.length);

                firestoreContentLoaded = messages.length > 0 && !(messages.length === 1 && messages[0].type === "system");
                storeContentLoaded = textStreamStore ? $textStreamStore.length > 0 : false;
                updateSplashScreenVisibility();

                tick().then(() => {
                    scrollToBottom();
                });
            } catch (error) {
                console.error("Error in displayActiveConversation:", error);
            }
        });


        // Attach status listeners only once per conversation
        setupStatusListener(convoId);
        //setupTextStreamListener(convoId);
    } catch (error) {
        console.error("Error:", error);
    }
    }




    function displayActiveConversation2(convoId) {
        try {
        // Reset the flag for Firestore content each time a new conversation is displayed
        firestoreContentLoaded = false;

        /*

        // Cleanup previous status listeners if any
        Object.values(messageStatusListeners).forEach(unsubscribe => unsubscribe());
        messageStatusListeners = {};

        // Detach the previous Firestore messages listener if it exists
        if (messagesListenerUnsubscribe) {
            messagesListenerUnsubscribe();
            messagesListenerUnsubscribe = null;
        }

        // Set up real-time listener for changes in Firestore
        const messagesRef = $db
            .collection("users")
            .doc($userID)
            .collection("deploymentUserData")
            .doc($clientUserID)
            .collection("clientSubUsers")
            .doc($emailHash) // Insert the user's email hash into the path
            .collection("conversations")
            .doc(convoId)
            .collection("messages");

            */

            try {
                let newFirestoreMessages = $statelessMessages;

                // Check if the textStreamStore is defined
                if (textStreamStore) {
                    // Update the textStreamStore with the new Firestore messages
                    textStreamStore.update(store => {
                        let updatedStore = store.filter(m => !newFirestoreMessages.find(fm => fm.messageId === m.messageId));
                        return updatedStore;
                    });
                    if (get(textStreamStore).find(m => m.finishedStreaming)) {
                        console.log("WE DELETING TEXTSTREAM STORE @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");
                        textStreamStore.set([]);
                    }
                }
                

                // Set the messages array with the new Firestore messages
                messages = newFirestoreMessages;
                console.log("We running the dAC message array set block, this is messages.length:", messages.length);

                firestoreContentLoaded = messages.length > 0 && !(messages.length === 1 && messages[0].type === "system");
                storeContentLoaded = textStreamStore ? $textStreamStore.length > 0 : false;
                updateSplashScreenVisibility();

                tick().then(() => {
                    scrollToBottom();
                });
            } catch (error) {
                console.error("Error in displayActiveConversation:", error);
            }



        // Attach status listeners only once per conversation
        setupStatusListener2(convoId);
        //setupTextStreamListener(convoId);
    } catch (error) {
        console.error("Error:", error);
    }
    }





function setupTextStreamListener(convoId) {
    const unsubscribe = socketStore.subscribe(socket => {
        if (!socket) return;


        textStreamStore = getTextStreamStore(convoId);
        currentTextStreamConvoId = convoId;


        shouldDisplayTexStreamMessage = get(textStreamStore).length > 0;
        storeContentLoaded = shouldDisplayTexStreamMessage;
        //console.log("these are sDTSM and sCL at outset:", shouldDisplayTexStreamMessage, storeContentLoaded);

        // Clear existing 'chatMessage' event listeners to prevent duplicates
        $socketStore.off('chatMessage');


        $socketStore.on('chatMessage', (payload) => {
            //console.log('chatMessage event received in sTSL', payload);

            // Ensure the message is relevant to the current conversation
            if (payload.conversationId === convoId) {
                let assistantMessage = $textStreamStore.find(m => m.messageId === payload.messageId) || {
                    type: 'assistant',
                    text: '',
                    modeId: payload.modeId,
                    messageId: payload.messageId
                };

                if (payload.event === 'done') {
                    console.log('Stream ended at:', new Date().toISOString());
                    console.log("Completion tokens:", payload.completionTokens);
                    assistantMessage.finishedStreaming = true;
                    textStreamStore.set([assistantMessage]);
                    isStreaming.set(false);


                    /*// Update the corresponding Firestore document
                    const messagesRef = $db
                        .collection("users")
                        .doc($userID)
                        .collection("deploymentUserData")
                        .doc($clientUserID)
                        .collection("clientSubUsers")
                        .doc($emailHash)
                        .collection("conversations")
                        .doc(convoId)
                        .collection("messages")
                        .doc(payload.messageId);

                    messagesRef.set({
                        message: { role: "assistant", content: $textStreamStore.find(m => m.messageId === payload.messageId).text + " This the SHIITO" },
                        timestamp: firebase.firestore.FieldValue.serverTimestamp(), // Adding the timestamp field
                    })
                    .then(() => {
                        console.log("Firestore document updated successfully");
                    })
                    .catch((error) => {
                        console.error("Error updating Firestore document:", error);
                    });*/
                } else {
                    try {
                        if (payload.data && payload.data.choices && payload.data.choices.length > 0 && payload.data.choices[0].delta && payload.data.choices[0].delta.content) {
                            assistantMessage.text += payload.data.choices[0].delta.content;
                            // Now, set shouldDisplayTexStreamMessage true only if there's content to display
                            shouldDisplayTexStreamMessage = assistantMessage.text.trim().length > 0;
                            //console.log("This sdTSM state:", shouldDisplayTexStreamMessage)
                            //console.log("This sCL state:", storeContentLoaded)
                            if (shouldDisplayTexStreamMessage !== storeContentLoaded) {
                                storeContentLoaded = shouldDisplayTexStreamMessage;
                                updateSplashScreenVisibility();
                                console.log("We running FLIP block:", shouldDisplayTexStreamMessage, storeContentLoaded)
                            } else {
                                //console.log("we are NOT running flip bloqq", shouldDisplayTexStreamMessage, storeContentLoaded)
                            }
                            textStreamStore.set([assistantMessage]);
                            //console.log('Received data:', payload.data.choices[0].delta.content);
                            scrollToBottom();
                        }
                    } catch (e) {
                        console.error('Error parsing data:', e);
                    }
                }
            } else {
                // Else block to handle messages from different conversation IDs
                let alternateTextStreamStore = getTextStreamStore(payload.conversationId);
                let assistantMessage = get(alternateTextStreamStore).find(m => m.messageId === payload.messageId) || {
                    type: 'assistant',
                    text: '',
                    modeId: payload.modeId,
                    messageId: payload.messageId
                };

                if (payload.event === 'done') {
                    console.log('Alternate stream ended at:', new Date().toISOString());
                    console.log("Completion tokens for alternate stream:", payload.completionTokens);
                    assistantMessage.finishedStreaming = true;
                    alternateTextStreamStore.set([assistantMessage]);
                    isStreaming.set(false);


                    /*// Update the corresponding Firestore document for the alternate conversation
                    const messagesRef = $db
                        .collection("users")
                        .doc($userID)
                        .collection("deploymentUserData")
                        .doc($clientUserID)
                        .collection("clientSubUsers")
                        .doc($emailHash)
                        .collection("conversations")
                        .doc(payload.conversationId)
                        .collection("messages")
                        .doc(payload.messageId);

                    messagesRef.set({
                        "message": { role: "assistant", content: get(alternateTextStreamStore).find(m => m.messageId === payload.messageId).text + " This the FUCKKO" },
                        timestamp: firebase.firestore.FieldValue.serverTimestamp(), // Adding the timestamp field
                    })
                    .then(() => {
                        console.log("Firestore document updated successfully for alternate conversation");
                        console.log("This is current textStreamStore", textStreamStore);
                    })
                    .catch((error) => {
                        console.error("Error updating Firestore document for alternate conversation:", error);
                    });*/
                } else {
                    try {
                        if (payload.data && payload.data.choices && payload.data.choices.length > 0 && payload.data.choices[0].delta && payload.data.choices[0].delta.content) {
                            assistantMessage.text += payload.data.choices[0].delta.content;
                            alternateTextStreamStore.set([assistantMessage]);
                            //console.log('Received data for alternate stream:', payload.data.choices[0].delta.content);
                        }
                    } catch (e) {
                        console.error('Error parsing data for alternate stream:', e);
                    }
                }
            }
        });


        $socketStore.on('stream_error', (error) => {
            console.error('Stream error MEAN:', error);
            //stopStreamButton.classList.add('hidden'); // Hide the stop button
        });

/*        onDestroy(() => {
            clearTextStreamStore(convoId); // Ensures cleanup for the specific conversation
        });*/
    });

    onDestroy(() => {
        unsubscribe(); // Clean up the subscription when the component is destroyed
    });

}


    function updateConversationStatus(newStatus) {
        conversationStatus = newStatus;
    }


function setupTextStreamListener2() {
    const unsubscribe = socketStore.subscribe(socket => {
        if (!socket) return;

        const convoId = "Main";

        textStreamStore = getTextStreamStore(convoId);
        currentTextStreamConvoId = convoId;


        shouldDisplayTexStreamMessage = get(textStreamStore).length > 0;
        storeContentLoaded = shouldDisplayTexStreamMessage;
        //console.log("these are sDTSM and sCL at outset:", shouldDisplayTexStreamMessage, storeContentLoaded);

        // Clear existing 'chatMessage' event listeners to prevent duplicates
        $socketStore.off('chatMessage');


        $socketStore.on('chatMessage', (payload) => {
            //console.log('chatMessage event received in sTSL', payload);

            // Ensure the message is relevant to the current conversation
            if (payload.conversationId === convoId) {
                let assistantMessage = $textStreamStore.find(m => m.messageId === payload.messageId) || {
                    type: 'assistant',
                    text: '',
                    modeId: payload.modeId,
                    messageId: payload.messageId
                };

                if (payload.event === 'done') {
                    console.log('Stream ended at:', new Date().toISOString());
                    console.log("Completion tokens:", payload.completionTokens);
                    assistantMessage.finishedStreaming = true;
                    textStreamStore.set([assistantMessage]);
                    addStatelessMessage(assistantMessage);
                    isStreaming.set(false);
                    successStatusListener2();

                } else {
                    try {
                        if (payload.data && payload.data.choices && payload.data.choices.length > 0 && payload.data.choices[0].delta && payload.data.choices[0].delta.content) {
                            assistantMessage.text += payload.data.choices[0].delta.content;
                            // Now, set shouldDisplayTexStreamMessage true only if there's content to display
                            shouldDisplayTexStreamMessage = assistantMessage.text.trim().length > 0;
                            if (shouldDisplayTexStreamMessage !== storeContentLoaded) {
                                storeContentLoaded = shouldDisplayTexStreamMessage;
                                updateSplashScreenVisibility();
                                console.log("We running FLIP block:", shouldDisplayTexStreamMessage, storeContentLoaded)
                            } else {
                                //console.log("we are NOT running flip bloqq", shouldDisplayTexStreamMessage, storeContentLoaded)
                            }
                            textStreamStore.set([assistantMessage]);
                            //console.log('Received data:', payload.data.choices[0].delta.content);
                            scrollToBottom();
                        }
                    } catch (e) {
                        console.error('Error parsing data:', e);
                    }
                }
            } else {
                // Else block to handle messages from different conversation IDs
                let alternateTextStreamStore = getTextStreamStore(payload.conversationId);
                let assistantMessage = get(alternateTextStreamStore).find(m => m.messageId === payload.messageId) || {
                    type: 'assistant',
                    text: '',
                    modeId: payload.modeId,
                    messageId: payload.messageId
                };

                if (payload.event === 'done') {
                    console.log('Alternate stream ended at:', new Date().toISOString());
                    console.log("Completion tokens for alternate stream:", payload.completionTokens);
                    assistantMessage.finishedStreaming = true;
                    alternateTextStreamStore.set([assistantMessage]);
                    isStreaming.set(false);

                } else {
                    try {
                        if (payload.data && payload.data.choices && payload.data.choices.length > 0 && payload.data.choices[0].delta && payload.data.choices[0].delta.content) {
                            assistantMessage.text += payload.data.choices[0].delta.content;
                            alternateTextStreamStore.set([assistantMessage]);
                            //console.log('Received data for alternate stream:', payload.data.choices[0].delta.content);
                        }
                    } catch (e) {
                        console.error('Error parsing data for alternate stream:', e);
                    }
                }
            }
        });


        $socketStore.on('stream_error', (error) => {
            console.error('Stream error MEAN:', error);
            //stopStreamButton.classList.add('hidden'); // Hide the stop button
        });


    });

    onDestroy(() => {
        unsubscribe(); // Clean up the subscription when the component is destroyed
    });

}



    function setupStatusListener(convoId) {

/*        if ($isStatelessUserFlag) {
            const messageStatusRef = $db.collection('messageStatusesSTATELESS').doc(messageId);

        } else {*/

            const conversationRef = $db
                .collection("users").doc($userID)
                .collection("deploymentUserData").doc($clientUserID)
                .collection("clientSubUsers").doc($emailHash)
                .collection("conversations").doc(convoId);

            // No need for activeListeners, handling only the current activeMessageStatusId
            conversationRef.onSnapshot(doc => {
                const data = doc.data();
                const statusId = data.activeMessageStatusId;

                if (statusId && !messageStatusListeners[statusId]) {
                    let messageStatusRef = $db.collection('messageStatuses').doc(statusId);
                    messageStatusListeners[statusId] = messageStatusRef.onSnapshot(statusSnapshot => {
                        const statusData = statusSnapshot.data();
                        if (statusData) {
                            updateConversationStatus(statusData.status);
                            if (statusData.status === 'success' || statusData.status === 'error') {
                                removeStatusListener(convoId, statusId);
                            }
                        }
                    });
                }
            });

        //}

    }


    function removeStatusListener(convoId, statusId) {
    // Unsubscribe the listener
    if (messageStatusListeners[statusId]) {
        messageStatusListeners[statusId]();
        delete messageStatusListeners[statusId];
    }

    // Update Firestore to reflect that this statusId no longer needs listening
    const conversationRef = $db
        .collection("users").doc($userID)
        .collection("deploymentUserData").doc($clientUserID)
        .collection("clientSubUsers").doc($emailHash)
        .collection("conversations").doc(convoId);

    // Assuming you want to set activeMessageStatusId to null or handle it differently
    conversationRef.update({
        activeMessageStatusId: "" // Or whatever update you need
    }).then(() => {
        console.log(`Conversation ${convoId} updated to remove activeMessageStatusId ${statusId}`);
    }).catch(error => {
        console.error("Error updating document: ", error);
    });
}



    function setupStatusListener2(messageId) {
        if ($isStatelessUserFlag && messageId && !messageStatusListeners[messageId]) {
            let messageStatusRef = $db.collection('messageStatusesSTATELESS').doc(messageId);
            messageStatusListeners[messageId] = messageStatusRef.onSnapshot(statusSnapshot => {
                const statusData = statusSnapshot.data();
                if (statusData) {
                    updateConversationStatus(statusData.status);
                    if (statusData.status === 'success' || statusData.status === 'error') {
                        removeStatusListener2(messageId);
                    }
                }
            });
        }
    }

    async function successStatusListener2() {
        let messageStatusRef = $db.collection('messageStatusesSTATELESS').doc($daMessageId);
                await messageStatusRef.update({
                    status: 'success',
                    errorTimestamp: firebase.firestore.FieldValue.serverTimestamp(),
                });
    }

    function removeStatusListener2(messageId) {
        if (messageStatusListeners[messageId]) {
            messageStatusListeners[messageId]();
            delete messageStatusListeners[messageId];
            console.log(`Status listener for message ${messageId} removed.`);
        }
    }



    // Cleanup message status listeners when the component is destroyed
    onDestroy(() => {
        Object.values(messageStatusListeners).forEach(unsubscribe => unsubscribe());
        if (messagesListenerUnsubscribe) {
            messagesListenerUnsubscribe();
        }
    });

    // Reactive statement to update messages style
    $: messagesStyle =
        messages.length === 1 && messages[0].type === "system"
            ? "background-color: transparent; box-shadow: none;"
            : "background-color: var(--primary-bg); box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);";
</script>

<div class="chat-area">
    {#if showSplashScreen}
        <div class="splash-screen-container" style={styleOverrides}>
            {#if $splashScreenArtUrl}
                <img
                    src={$splashScreenArtUrl}
                    class="splash-screen"
                    alt="Splash Screen"
                />
            {/if}
            {#if $textCopy}
                <div class="text-copy" style={styleOverrides}>
                    {$textCopy}
                </div>
            {/if}
        </div>
    {/if}
    <div class="ai-toggle">
        <AiAgentToggle />
    </div>
    <div class="messages" style={messagesStyle}>
        <div class="message-wrapper">
            {#each messages as message}
                {#if message.type !== "system"}
                    <Message type={message.type} text={message.text} modeId={message.modeId} />
                {/if}
            {/each}

            {#if shouldDisplayTexStreamMessage}
                {#each $textStreamStore as message}
                    {#if message.type !== "system"}
                        <Message type={message.type} text={message.text} modeId={message.modeId} />
                    {/if}
                {/each}
            {/if}
        </div>

        
        <!-- Display the conversation status here -->
        {#if conversationStatus && conversationStatus !== 'success' && conversationStatus !== 'error'}
            <div class="conversation-status">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                    <circle cx="50" cy="50" r="32" stroke-width="8" stroke="#3c0f0f" stroke-dasharray="50.26548245743669 50.26548245743669" fill="none" stroke-linecap="round">
                      <animateTransform attributeName="transform" type="rotate" dur="0.8474576271186441s" repeatCount="indefinite" keyTimes="0;1" values="0 50 50;360 50 50"></animateTransform>
                    </circle>
                    <circle cx="50" cy="50" r="23" stroke-width="8" stroke="#f91a10" stroke-dasharray="36.12831551628262 36.12831551628262" stroke-dashoffset="36.12831551628262" fill="none" stroke-linecap="round">
                      <animateTransform attributeName="transform" type="rotate" dur="0.8474576271186441s" repeatCount="indefinite" keyTimes="0;1" values="0 50 50;-360 50 50"></animateTransform>
                    </circle>
                    <!-- [ldio] generated by https://loading.io/ -->
                </svg>
                <div class={statusClass}>{conversationStatus}</div>
            </div>
        {/if}
        <div class="buffer-space" />
    </div>
        {#if $footerLinkData && Object.keys($footerLinkData).length > 0}
          <div class="FTL-linkshit" style={styleOverrides}>
            <span>
              {$footerLinkData.precedingText} 
              <a href="{$footerLinkData.linkDestinationUrl}" style="color: #0088cc; text-decoration: none;">
                {$footerLinkData.linkText}
              </a>
            </span>
          </div>
        {/if}
    

    <div class="text-input">
        <TextInputArea {$userID} {$clientUserID} />
    </div>
</div>

<style>
.conversation-status {
    background-color: var(--secondary-bg); /* A secondary background color for distinction */
    color: var(--primary-text); /* Use the primary text color for readability */
    padding: 10px; /* Adequate padding for visual comfort */
    border-radius: 5px; /* Slightly rounded corners */
    margin: 10px; /* Margin to keep it spaced from other elements */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05); /* Subtle shadow for depth */
    font-size: 0.9rem; /* Slightly smaller font size than main content */
    font-weight: 500; /* Medium font weight for emphasis */
    text-align: center; /* Center the text for better focus */
}

.conversation-status svg {
        margin-top: 10px; 
        width: 40px;
        height: 40px;
    }

    .status-color-x { color: #008080; }
    .status-color-blahblah { color: #96810f; }
    .status-color-yoyo { color: #556B2F; }


    .chat-area {
        position: relative;
        width: 100%;
        height: 100vh;
        padding: 0px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        background-color: var(--primary-bg); /* Default background color */
        background-size: cover; /* Ensure the splash screen covers the entire area */
        background-position: center; /* Center the background image */
        transition: background-image 0.3s; /* Smooth transition for background change */
    }

    .messages {
        display: flex;
        flex-direction: column; /* Stack children vertically */
        flex: 1; /* Allow this container to grow and occupy remaining space */
        overflow-y: auto;
        padding: 0px;
        border-radius: 10px;
        background-color: var(--primary-bg);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .message-wrapper {
        flex-grow: 1; /* Allow this div to grow and occupy available space */
        display: flex;
        flex-direction: column;
    }

    .buffer-space {
        height: 16vh;
        background-color: white;
        flex-shrink: 0;
    }

    .ai-toggle,
    .text-input {
        margin-bottom: 10px;
    }


    .splash-screen-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 50%; /* Positioned at the vertical center */
        left: 50%; /* Positioned at the horizontal center */
        transform: translate(-50%, -75%); /* Shift horizontally and vertically */
        /* The container is now shifted 5% above the vertical center */
        flex-direction: column; /* Stack items vertically */
/*this animation*/
        transition: opacity var(--fade-duration, 0.3s) ease-in-out, 
                    visibility var(--fade-duration, 0.3s) ease-in-out;
        opacity: 1; /* Start fully visible */
        visibility: visible; /* Start visible */
    }

    .no-interaction {
        pointer-events: none;
        opacity: 0.5; /* Optional visual feedback */
    }

    .text-copy {
        margin-top: 1rem; /* Space between the image and the text */
        padding: 0 2rem; /* Horizontal padding */
        text-align: center; /* Center the text */
        font-size: 1.5rem; /* Adjust font size as needed */
        font-weight: 600;
        color: #333; /* Text color */
        max-width: 700px; /* Consistent with the splash screen image width */
/*this animation*/
        transition: opacity var(--fade-duration, 0.3s) ease-in-out, 
                    visibility var(--fade-duration, 0.3s) ease-in-out;
        opacity: 1; /* Start fully visible */
        visibility: visible; /* Start visible */
    }

    .FTL-linkshit {
        padding: 10px 0px 10px 5px; 
        font-size: 0.8rem; 
        color: #555; 
        bottom: 4%; 
        left: 0%; 
        transform: translateX(0%); 
        z-index: 10;
/*this animation*/
        transition: opacity 0s ease-in-out, visibility 0s ease-in-out;
        opacity: 1; /* Start fully visible */
        visibility: visible; /* Start visible */
    }

    .splash-screen {
        max-width: 42vw; /* Maximum width relative to viewport width */
        max-height: 45vh; /* Maximum height relative to viewport height */
        width: auto; /* Auto width for maintaining aspect ratio */
        height: auto; /* Auto height for maintaining aspect ratio */
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Optional shadow for consistency */
    }
</style>
